import { ChangeDetectionStrategy, Component, ElementRef, Input, signal, ViewChild, WritableSignal } from "@angular/core";
import { SafeHtml } from "@angular/platform-browser";

@Component({
  selector: "app-right-arrow",
  standalone: true,
  templateUrl: "./arrow-right.svg",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RightArrowSvgComponent {
  @Input() fill;
  @Input() height: string = "auto";
  @Input() width: string = "auto";

  svgContent: WritableSignal<SafeHtml> = signal(undefined);

  @ViewChild("div") div: ElementRef;
}
